import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { getValue } from '_utils';
import {
  getMaxExpiryDateForPool,
  getMaxExpiresDaysAfterInitForPool,
  getACLicensePoolSelectionOptions
} from '_utils/licensePools';

import { AC_TYPES, LICENSE_POOL_TYPES } from "../../server/constants";

import {
  Form,
  Button
} from 'semantic-ui-react';

import BaseNumberField from '_forms/baseNumber';
import BaseInputField from '_forms/baseInput';
import BaseDateField from '_forms/baseDate';
import AcSourceField from '_forms/source';
import AcTypeField, { AC_TYPE_OPTIONS } from '_forms/acType';
import SessionLengthField from '_forms/sessionLengthField';

const InstitutionBatchACForm = ({
  data,
  institution,
  onChange,
  onSubmit
}) => {

  const onFieldChange = (_, field) => onChange(field.name, getValue(field));

  const poolOptions = getACLicensePoolSelectionOptions(institution.license_pools);
  const selectedPool = institution.license_pools.find(p => p._id === data.license_pool_id);

  return (
    <Form size='tiny' onSubmit={ onSubmit } >
      <Form.Group>
        <AcSourceField
          width={12}
          name='license_pool_id'
          placeholder='Select a License Pool'
          value={ data.license_pool_id }
          options={ poolOptions }
          onChange={ onFieldChange }
        />
      </Form.Group>
      <Form.Group>
        <AcTypeField
          width={ 6 }
          name='type'
          options={
            AC_TYPE_OPTIONS.map(o => Object.assign({}, o, {
              disabled: !selectedPool || (selectedPool.type === LICENSE_POOL_TYPES.SUBSCRIPTION && o.value === AC_TYPES.FULL)
            }))
          }
          value={data.type}
          // If selected pool is of type "full", default to AC type "full"
          defaultValue={selectedPool && selectedPool.type === LICENSE_POOL_TYPES.FULL ? LICENSE_POOL_TYPES.FULL : null}
          onChange={ onFieldChange }
        />
        {
          data.type === AC_TYPES.TERM_DAYS
            ? <BaseNumberField
              width={ 6 }
              name='expires_days_after_init'
              min={ 1 }
              max={ getMaxExpiresDaysAfterInitForPool(selectedPool) }
              value={ data.expires_days_after_init }
              onChange={ onFieldChange }
              labelTxt='Expire set days after activation'
              popupTxt='The end user will get this many number of days to use Max, starting when they activate.'
            />
            : null
        }
        {
          data.type === AC_TYPES.TERM_DATE
            ? <BaseDateField
              width={ 6 }
              name='expires_on'
              value={data.expires_on}
              defaultValue={selectedPool.expires_on} // Fallback to license pool expiry date
              onChange={ onFieldChange }
              maxDate={ getMaxExpiryDateForPool(selectedPool) }
              minDate={ moment().add(1, 'days') }
              labelTxt='Expires On'
              popupTxt='Set a fixed expiration date.'
            />
            : null
        }
      </Form.Group>
      <Form.Group>
        <BaseNumberField
          width={ 6 }
          name='license_count'
          min={ 1 }
          value={ data.license_count }
          onChange={ onFieldChange }
          labelTxt='License Count'
          popupTxt='How many licenses to use per AC? For individual use, set this to 1.  For labs and special accounts set this to the number of machines on which you wish to run Max.'
        />
        <SessionLengthField
          width={ 6 }
          name='session_length_min'
          lengthInMinutes={ data.session_length_min }
          onChange={ onFieldChange }
        />
      </Form.Group>
      <Form.Group>
        <BaseInputField width={ 12 } name='description'
          type='text'
          value={ data.description }
          onChange={ onFieldChange }
          labelTxt='Description (optional)'
          popupTxt='Set a description/note for your reference.'
        />
      </Form.Group>
      <Form.Group>
        <BaseNumberField
          width={ 6 }
          name='count'
          min={ 1 }
          value={ data.count }
          onChange={ onFieldChange }
          labelTxt='Number of Codes'
          popupTxt='We can create ACs in batches by type and license source (Max 7, Max 8, Subscription). How many of this type of AC to create?'
        />
      </Form.Group>
      <Button.Group>
        <Button positive type="submit">Create Codes</Button>
      </Button.Group>
    </Form>
  );
};

InstitutionBatchACForm.propTypes = {
  data: PropTypes.shape({
    license_pool_id: PropTypes.string,
    type: PropTypes.oneOf(Object.values(AC_TYPES)),
    count: PropTypes.number.isRequired,
    license_count: PropTypes.number.isRequired,
    session_length_min: PropTypes.number.isRequired,
    description: PropTypes.string.isRequired,

    expires_on: PropTypes.oneOfType([
      PropTypes.instanceOf(Date),
      PropTypes.instanceOf(moment),
      PropTypes.string
    ]),
    expires_days_after_init: PropTypes.number

  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  institution: PropTypes.object.isRequired,
}

export default InstitutionBatchACForm;



// WEBPACK FOOTER //
// ./webAdmin/forms/acBatchInstitution.js